import React from 'react';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledHeader = styled('h2', {
  height: 36,
  fontSize: 35,
  fontWeight: 400,
  marginBottom: 10,
});

export const WelcomeText = () => {
  const { user } = useUser.state();
  const { firstName } = user;

  return (
    <StyledHeader
      data-testid='user-error-dialog-title'
      data-uhc-brand='font--heading color--blue'
    >
      {firstName ? `Welcome, ${firstName}!` : 'Welcome!'}
    </StyledHeader>
  );
};
